<template>
  <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Tipos de Visita:"
    id="selectTipoEvento"
    placeholder="Selecione o tipo de visita"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isRequired="true"
  ></NxSelect>
</template>
<script>
import VisitTypeRepository from '@/shared/http/repositories/configurations/visittype.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectTipoVisita',
  mixins: [useReactiveModelMixin('value')],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadEventos()
  },
  methods: {
    async onLoadEventos () {
      try {
        loading.push()
        const response = await VisitTypeRepository.GetAll()

        if (!response || !response.data || !response.data.content) return

        this.listOptions = response.data.content.map((content) => ({
          value: content.id,
          text: content.visitName
        }))
      } catch (error) {
        toast.error(
          'Não foi possível carregar a lista de tipos de visita',
          'Erro'
        )
        console.error(error)
      } finally {
        loading.close()
      }
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoVisita.vue